import React, { useState } from "react";
import ContributorData from "./ContributorData";

const Contributors = () => {
  const [date, setDate] = useState("2023");
  
  return (
    <div className="contributors" data-aos="fade-up">
      <div className="contributorsHeader">
        <h1 data-aos="fade-down" data-aos-delay="100">
          Our Generous Benefactors
        </h1>
        <select 
          value={date} 
          onChange={(e) => setDate(e.target.value)}
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <option value="2021">2021</option>
          <option value="2022">2022</option>
          <option value="2023">2023</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
        </select>
      </div>
      <div className="contributorNames" data-aos="fade-up" data-aos-delay="300">
        {ContributorData[date] && ContributorData[date].map((name, index) => {
          return <p key={index}>{name}</p>;
        })}
      </div>
    </div>
  );
};

export default Contributors;
